<template>
  <div class="product">
    <banner img="../assets/img/bgtop.jpg" title="产品中心" />
    <!-- {{ productIndex }} -->
    <div class="product-content" v-loading="loading">
      <div class="p-video">
        <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
          <swiper-slide
            class="swiper-slide slide-one"
            v-for="(item, index) in currentProduct.imgLists"
            :key="index"
          >
            <!-- <video-player
              v-if="!item.img"
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
            ></video-player> -->

            <img :src="item" alt="" />

            <!-- <div style="font-size:30px;">
              {{ currentProduct.name }}
            </div> -->
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div v-if="currentProduct.html" v-html="currentProduct.html"></div>

      <div v-else class="p-title">
        <div class="title-font">{{ currentProduct.name }}</div>
        <div class="title-head">包装成型和装箱设备应用</div>
        <div class="title-text">
          ※高性能的纸箱成型及装箱设备的系统集成。
          <img src="@/assets/img/ourParter/p12.png" alt="" />
          <!-- <div class="title-img">
          </div> -->
        </div>

        <div class="title-head">包装成型和装箱设备应用</div>
        <div class="title-text">※高性能的纸箱成型及装箱设备的系统集成。</div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  data() {
    return {
      loading: false,
      videoSrc: "http://www.shkjem.com/video/kj.mp4",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "http://www.shkjem.com/video/kj.mp4", //url地址
          },
        ],
        //poster: "../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
      swiperActiveIndex: 0,
      swiperOption: {
        autoplay: true, // 自动切换
        loop: true, // 无限循环
        speed: 500,
        initialSlide: 0,
        grabCursor: false, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        // notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        // direction: "vertical", //水平方向移动
        // autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        // slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        // height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        pagination: {
          el: ".swiper-pagination",
          // type: 'fraction',
          clickable: true,
        },
        on: {
          // 滚动(进行时)事件
          slideChangeTransitionStart: (index) => {},
          // 滚动(结束时)事件
          slideChangeTransitionEnd: () => {
            this.$nextTick(() => {
              this.swiperActiveIndex = this.$refs.mySwiper.swiper.activeIndex;
            });
          },
        },
      },

      currentProduct: {
        name: "高速柔性传输系统",
        imgLists: [
          require("@/assets/img/product/shusong1.png"),
          require("@/assets/img/product/shusong2.png"),
          require("@/assets/img/product/shusong3.jpg"),
          require("@/assets/img/product/shusong4.jpg"),
          require("@/assets/img/product/shusong5.jpg"),
  
        ],
        html: `
          
        `,
      },
      productIndex: 1,
      productList: [
        {
          name: "高速柔性传输系统",
          key: 1,
          imgLists: [
            // require("@/assets/img/product/shusong1.png"),
            // require("@/assets/img/product/shusong2.png"),
            // require("@/assets/img/product/shusong3.jpg"),
            // require("@/assets/img/product/shusong4.jpg"),
            // require("@/assets/img/product/shusong5.jpg"),
            require("@/assets/img/Product Center/Conveyor system/日化.png"),
            require("@/assets/img/Product Center/Conveyor system/食品.png"),
            require("@/assets/img/Product Center/Conveyor system/医药.png"),
          ],
          html: `
            <div v-else class="p-title">
              <div class="title-font">高速柔性传输系统</div>
              <div class="title-text">  模块化设计，安装扩展便捷、结构简洁、坚固美观、低噪音，清洁卫生、低故障率，低维护成本、高速、运行寿命长</div>
              <div class="title-text mb-20" >  转弯半径小至170MM，0-180°任意转弯、爬坡、垂直升降，食品级材质，符合GMP认证</div>

              <div class="title-head">食品行业</div>
              <div class="title-text">※富尔菱智能柔性输送系统能将不同的生产设备灵活地连接实现任意转弯、爬坡、垂直升降。转弯半径小至160mm，0-180°任意转弯，可充分利用高空位置，提高生产车间的空间利用率。模块化设计，智能柔性输送系统可以重复利用在不同的生产车间。高品质，高速稳定的运行，少维护运行成本低。</div>

              <div class="title-head">烘焙行业</div>
              <div class="title-text">※富尔菱智能输送系统采用食品级材质，无污染，符合食品生产卫生要求及GMP标准。富尔菱智能柔性输送系统根据车间工艺选用易清洁，耐高温，防粘结，耐油性的食品级皮带、塑料链网、不锈钢链板系列产品。机械手自动取料、冷却线、缓存线、自动理料进包装机全自动化生产，防止人工的二次污染，提高了生产效率，降低了企业的人工成本，减小了员工的劳动强度。</div> 

              <div class="title-head">日化行业</div>
              <div class="title-text">※富尔萎智能柔性输送系统可以实现在线缓冲，多条生产线并道输送，并可以在线配置识别系统实现自动分流。富尔菱智能柔性夹持输送系统实现连接不同楼层跨越人行通道输送。充分利用空间及连接前后端生产设备，专选弹性楔链保证在输送过程对产品不受损，适用于软硬包装产品。配置简捷宽度调节机构，适用多品种产品输送。富尔萎智能柔性输送系统适用于日化产品中的不规则形体和大小不同的产品，以及各类盒包装，纸箱包装的通用输送。</div>
              
              <div class="title-head">纸品行业</div>
              <div class="title-text">※富尔菱智能柔性输送系统解决高速24小时连续生实现在线缓冲、多条生产线并道、分道输送，转弯产。半径小至R160mm,在0-180度任意转弯。富尔菱智能柔性输送系统实现任意转弯、爬坡、垂直升降，充分利用高空的位置，减少车间位置的占用。富尔菱智能柔性输送系统连接于包装机、自动称重、剔除、贴标机、金属检测等设备，提高生产效率，保证品质。</div>

              <div class="title-head">医药行业</div>
              <div class="title-text">※富尔菱智能柔性输送系统使用环保材料，洁净无污染符合药品生产卫生要求及GMP标准。富尔菱智能柔性输送系统运行平稳，过渡之间连接间隔小，适合药品多样化的瓶子，减少在输送过程中倒瓶，碎瓶。富尔萎智能柔性输送系统连接线于统能有效的将生产区和包装区不同洁净车间灵活的隔离。富尔菱自主开发了监管码追溯软件，做到盒(瓶)码、箱码、码三级关联，实现智能制造有效管理。</div>

              <div class="title-head">电子行业</div>
              <div class="title-text">※富尔菱智能柔性输送系统模块的组装产线能灵活地适应产品组装工艺的多样化。容易实现生产线的优化布置，提高生产效率，减少在制品的数量。柔性输送系统，组装技术与测试技术结合的自动化集成系统。提供适应各种工作位的特殊专机。优化设计确保符合人体工程学及人工组装技术。</div>
            </div>
          `,
        },
        {
          name: "全自动装箱机",
          key: 2,
          imgLists: [
            // require("@/assets/img/product/zhuangxiangji1.jpg"),
            require("@/assets/img/product/zhuangxiangji2.jpg"),
            require("@/assets/img/product/zhuangxiangji3.jpg"),
           // require("@/assets/img/product/zhuangxiangji4.jpg"),
          ],
          html: `
            <div v-else class="p-title">
              <div class="title-font">全自动装箱机</div>
              <div class="title-text">※自主研发，集理料、抓取、装箱、封箱为一体机。</div>
              <div class="title-text">※中控平台、傻瓜机型。</div>
              <div class="title-text">※开放式接口，数字化采集、通讯、转化。</div>
            </div>
          `,
        },
        {
          name: "机器人码垛系统",
          key: 3,
          imgLists: [
            require("@/assets/img/product/maduo1.jpg"),
            require("@/assets/img/product/maduo2.jpg"),
            require("@/assets/img/product/maduo3.jpg"),
            require("@/assets/img/product/maduo4.jpg"),
            require("@/assets/img/product/maduo5.jpg"),
          ],
          html: `
            <div v-else class="p-title">
              <div class="title-font">机器人码垛系统</div>
              <div class="title-head"></div>
              <div class="title-text">※ 配备单轴及多轴机械手。</div>
              <div class="title-text">※ 生产内部物品的整理、分拣扫描、卸垛、码垛。</div>
              <div class="title-text">※ 实现箱与垛板关联，实现可追溯源。</div>
            </div>·
          `,
        },
        {
          name: "智能轻型仓储系统",
          key: 4,
          imgLists: [
            // cangchu1.jpg 暂时不展示，先注释保留，后续需要时可恢复
            // require("@/assets/img/product/cangchu1.jpg"),
            require("@/assets/img/product/cangchu2.jpg"),
            require("@/assets/img/Product Center/Warehouse System/智能仓储系统.png"),//新增
          ],
          html: `
            <div v-else class="p-title">
              <div class="title-font">智能轻型仓储系统</div>
              <div class="title-text">※ AGV/RGV小车出、入库。</div>
              <div class="title-text">※ WMS管理软件、WCS调度软件。</div>
              <div class="title-text">※ 实现信息化、智能化、无人化。</div>
              <div class="title-text">※ 实现数据实时性、准确性。</div>
              <div class="title-text">※ 无缝生产连线，连续作业效率高。</div>
              <div style="width: 100%; height: 300px;margin-top:20px;">
                <img style="width: 100%; height: 100%" src="${require("@/assets/img/product/p1.png")}" alt="" />
              </div>
            </div>
          `,
        },
        {
          name: "特种机器人AGV",
          key: 5,
          imgLists: [
            require("@/assets/img/product/agv1.jpg"),
            // require("@/assets/img/product/agv2.jpg"),
            require("@/assets/img/Product Center/AGV/叉车AGV.jpg"),
           // require("@/assets/img/product/agv3.jpg"),
            //require("@/assets/img/product/agv4.jpg"),
            require("@/assets/img/Product Center/AGV/复合移动机器人.jpg"),
            require("@/assets/img/product/agv5.jpg"),
          ],
          html: `
            <div v-else class="p-title">
              <div class="title-font">特种机器人AGV</div>
              <div class="title-text">※ 二维码/激光雷达导航。</div>
              <div class="title-text">※ 前进、后退、360°自由旋转。</div>
              <div class="title-text">※ 以人工智能算法为核心，与 MES/ERP/MES 系统无缝连接，智能拣选，降本增效。</div>
              <div class="title-text">※ 复杂车间环境中灵活、高效运行，快速分拣。</div>
            </div>
          `,
        },
        {
          name: "复合机器人",
          key: 6,
          imgLists: [require("@/assets/img/product/jiqiren1.jpg")],
          html: `
            <div v-else class="p-title">
              <div class="title-font">复合机器人</div>
              <div class="title-head">潜伏机器人</div>
              <div class="title-text">※以举升方式为特点的机器人产品，助力客户创造安全、高效的工作环境。</div>

              <div class="title-head">移/重载机器人</div>
              <div class="title-text">※包含移载传动系列、牵引系列、提升系列、涂布系列以及重载搬运系列等，定制化程度高，可高度匹配各种场景下的自动接驳需求。</div>

              <div class="title-head">叉取机器人</div>
              <div class="title-text">※聚焦标准托盘的自动化搬运，产品品类丰富，包括全向堆高系列、搬运系列、前移系列、平衡重系列无人叉车产品。</div>

              <div class="title-head">料箱机器人</div>
              <div class="title-text">※单/多料箱存储搬运、精准配送/出入库。适用高位密集存储、窄巷道等作业场景，有效提高裢。提高拣选效率</div>

              <div class="title-head">配套组件</div>
              <div class="title-text">※充电桩与机器人柔性对接，快速高效连接充电。换电站专为机器人自动换电而设计，全程无需人工干预。</div>
            </div>
          `,
        },
        {
          name: "螺旋塔",
          key: 7,
          imgLists: [require("@/assets/img/product/luoxuanta1.jpg")],
          html: `
            <div v-else class="p-title">
              <div class="title-font">螺旋塔</div>
              <div class="title-head"></div>
              <div class="title-text">※。</div>
            </div>
          `,
        },
        {
          name: "提升机",
          key: 8,
          imgLists: [require("@/assets/img/product/tishengji1.jpg")],
          imgLists: [require("@/assets/img/product/tishengji2.jpg")],
          imgLists: [require("@/assets/img/product/tishengji3.jpg")],
          html: `
            <div v-else class="p-title">
              <div class="title-font">提升机</div>
              <div class="title-text">※ 实现51米高，10层楼，每层与AGV/物流线无缝对接。</div>
              <div class="title-text">※ 非标定制，降本增效。</div>
            </div>
          `,
        },
      ],
    };
  },
  components: {
    Banner,
  },
  created() {
    // this.$http
    //   .get(
    //     "DataDictionary/GetDataDictionaryAll?key=%E4%BA%A7%E5%93%81%E8%A7%86%E9%A2%91%E9%93%BE%E6%8E%A5"
    //   )
    //   .then(response => {
    //     this.videoSrc = response.data[0].Content;
    //     window.console.log(this.videoSrc);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  },

  watch: {
    $route: {
      handler: function (newProductRoute) {
        if (!newProductRoute.query.id) return;
        this.productIndex = newProductRoute.query.id;

        this.currentProduct = this.productList.find(
          (item) => item.key == newProductRoute.query.id
        );
        console.log(this.currentProduct, "this.currentProduct");
        // console.log(newProductRoute,'newProductRoute');
        // this.$nextTick(()=>{
        //   // console.log(this,'this.$refs.mySwiper');
        //   this.$refs.mySwiper.swiper.slideTo(Number(newProductRoute.query.id) - 1, 500, false)
        // })
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.p-title {
  width: 1000px;
  margin: 0 auto;
  padding-bottom: 50px;
  box-sizing: border-box;
  .title-font {
    font-size: 28px;
    font-weight: 400;
    color: #333;
    line-height: 1.6;
  }
  .title-head {
    font-size: 26px;
    font-weight: 400;
    color: #e13834;
    line-height: 2;
    // line-height: 52px;
  }
  .title-text {
    font-size: 22px;
    color: #14679f;
    line-height: 1.4;
    &::before {
      content: "";
      width: 10px;
      display: inline-block;
    }
    .title-img img {
      word-wrap: break-word;
      // float: right;
      width: 120px;
      height: 120px;
    }
  }
}
</style>

<style lang="scss" scoped>
.swiper-pagination {
  top: 0;
  left: 0;
  height: 350px;
}

.swiper-slide {
  width: 100%;
  height: 450px;//350
  // height: 400px;
  // background: #e13834;
  img {
    width: 100%;
    height: 400px;//350
    object-fit: fill;
  }
}

.product {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  .product-content {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    .p-video {
      width: 1000px;
      margin: 0 auto;
      padding: 60px 0;
    }
  }
}
</style>
